<template lang="html">
    <div>
        <div v-if="loading">
            <div style="text-align:center">
                <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <div v-if="loading == false">
            <div class="box">
                <div class="box-body" style="padding: 8px;">
                    <div class="row">
                        <div class="col-md-3">
                            <select2 name="Servisler"
                                     :data="services"
                                     :selected="filters.service"
                                     :maxSelection="1"
                                     :minSelection="1"
                                     v-on:onChange="onServiceFilterChanged" />
                        </div>
                        <div class="col-md-6"></div>
                        <div class="col-md-3">
                            <div class="float-lg-right">
                                <daterange :dateRange="filters.dateRange" v-on:onChange="onDateFilterChanged" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <autoupdate :loading="reportDataLoading" v-on:refreshData="loadData" />
            <div class="box">
                <div class="box-header" style="padding-top: 3px; padding-bottom:3px;">&nbsp;</div>
                <div class="box-tool" style="top: 4px;">
                    <ul class="nav">
                        <li class="nav-item inline">
                            <a class="nav-link" v-on:click="downloadCsv"><span class="fa fa-download"></span></a>
                        </li>
                    </ul>
                </div>
                <table2 :rows="data" :headers="tableHeaders" :hasTotalRow="true" />
            </div>
        </div>
    </div>
</template>

<script>
    import parallel from 'async/parallel';
    import AppLayout from '../../../components/app_layout.vue';
    import Select2 from '../../../components/select.v2.vue';
    import DateRange from '../../../components/daterange.vue';
    import AutoUpdate from '../../../components/auto_update.vue';
    import moment from 'moment';
    import Table2 from '../../../components/table.v2.vue';
    import TimezoneChangeMixin from '../../../mixins/timezone-change.vue';

    export default {
        mixins: [TimezoneChangeMixin],
        components: {
            'select2': Select2,
            'daterange': DateRange,
            'autoupdate': AutoUpdate,
            'table2': Table2
        },
        data: function () {
            return {
                filters: {
                    service: [],
                    dateRange: [moment(), moment()]
                },
                services: [],
                data: [],
                tableHeaders: [
                    {
                        columnName: 'country',
                        title: 'Ülke',
                        dataFormat: 'string'
                    },
                    {
                        columnName: 'method_total_otp',
                        title: 'Otp İsteği',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'method_total_flashcall',
                        title: 'FlashCall İsteği',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'method_total_fblogin',
                        title: 'FBLogin İsteği',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'method_total_fbacckit',
                        title: 'FBAccKit İsteği',
                        dataFormat: 'integer',
                        valueFormat: 'integer'
                    },
                    {
                        columnName: 'method_otp',
                        title: 'Otp',
                        dataFormat: 'integer',
                        regex: "[0-9]+"
                    },
                    {
                        columnName: 'method_flashcall',
                        title: 'FlashCall',
                        dataFormat: 'integer',
                        regex: "[0-9]+"
                    },
                    {
                        columnName: 'method_fblogin',
                        title: 'FBLogin',
                        dataFormat: 'integer',
                        regex: "[0-9]+"
                    },
                    {
                        columnName: 'method_fbacckit',
                        title: 'FBAccKit',
                        dataFormat: 'integer',
                        regex: "[0-9]+"
                    }
                ],
                loading: false,
                reportDataLoading: false,
                csvDownloadUrl: ''
            }
        },
        mounted: function () {
            var $this = this;
            this.loading = true;
            parallel([
                function (next) {
                    var params = {
                        dashboard_id: $this.$router.currentRoute.query.id
                    };
                    $this.$app.get('/api/v1/users/' + $this.$app.getUser().id + '/services', params, function(xhr) {
                        var response = xhr.responseJSON;
                        $this.services = $.map(response.services, function (service) {
                            return {
                                id: service.id,
                                text: service.name
                            }
                        });
                        var savedService = $this.$app.getValue('appverification.service.v2');
                        if (savedService !== null) {
                            $this.filters.service = savedService;
                        } else {
                            $this.filters.service = [$this.services[0].id];
                        }
                        next();
                    });
                }
            ], function (err, results) {
                $this.loading = false;
                $this.loadData();
            });
        },
        methods: {
            loadData: function () {
                this.reportDataLoading = true;
                var $this = this;
                var params = {
                    id: this.$router.currentRoute.query.id,
                    service_id: this.filters.service,
                    start_date: this.filters.dateRange[0].format('YYYY-MM-DD 00:00:00'),
                    end_date: this.filters.dateRange[1].format('YYYY-MM-DD 23:59:59')
                };
                this.$app.get('/api/v1/dashboards/report/appverification/countries-data', params, function(xhr) {
                    $this.reportDataLoading = false;
                    var response = xhr.responseJSON;
                    $this.data = response.data;
                    params.access_token = $this.$app.getAccessToken();
                    params.csv = 1;
                    $this.csvDownloadUrl = '/api/v1/dashboards/report/appverification/countries-data?' + $.param(params);
                }, {'Timezone': this.$app.getTimezone()});
            },
            formatDate: function (date) {
                return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
            },
            downloadCsv: function () {
                if (this.csvDownloadUrl !== '') {
                    window.open(this.csvDownloadUrl);
                }
            },
            onServiceFilterChanged: function (data) {
                this.filters.service = data;
                this.$app.setValue('appverification.service.v2', data);
                this.loadData();
            },
            onDateFilterChanged: function (data) {
                this.filters.dateRange = data;
                this.loadData();
            }
        }
    }
</script>


// WEBPACK FOOTER //
// countries.vue?3f7b06f1